import React, { PureComponent } from 'react';
import '../App.css';
import firebase, { auth, provider } from '../firebase.js';
import {Alert, ToggleButtonGroup, ToggleButton, Button, Well, Glyphicon, ProgressBar, Tabs, Tab, Panel, PanelGroup} from 'react-bootstrap';
import { StickyContainer, Sticky} from 'react-sticky';
//const jsPDF = require('jspdf');
import jsPDF from 'jspdf';
import {Link, useParams, useLocation, withRouter} from "react-router-dom";
import mainLogo from'../orthopowertools.png';
//import queryString from 'query-string'; don't think I'll use this line

///////////////////////////////////////////Calculator Methods
    

class Buttons1 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent1(value);
    if (value === 0)
        this.props.callbackFromParent1_text('No difficulty opening a tight or new jar');
    if (value === 25)
        this.props.callbackFromParent1_text('Slight difficulty opening a tight or new jar');
    if (value === 50)
        this.props.callbackFromParent1_text('Moderate difficulty opening a tight or new jar');
    if (value === 75)
        this.props.callbackFromParent1_text('Severe difficulty opening a tight or new jar');
    if (value === 100)
        this.props.callbackFromParent1_text('Unable to open a tight or new jar');
    this.setState({clicked: value});
    }

  render() {
	return (
    <div>
    <div class="hidden-xs">
    <h4>Open a tight or new jar</h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <h4>Open a tight or new jar</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}


class Buttons2 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent2(value);
    if (value === 0)
        this.props.callbackFromParent2_text('No difficulty doing heavy household chores');
    if (value === 25)
        this.props.callbackFromParent2_text('Slight difficulty doing heavy household chores');
    if (value === 50)
        this.props.callbackFromParent2_text('Moderate difficulty doing heavy household chores');
    if (value === 75)
        this.props.callbackFromParent2_text('Severe difficulty doing heavy household chores');
    if (value === 100)
        this.props.callbackFromParent2_text('Unable to do heavy household chores');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>Do heavy household chores (e.g. wash walls, wash floors) </h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <h4>Do heavy household chores (e.g. wash walls, wash floors) </h4>
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}


class Buttons3 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent3(value);
    if (value === 0)
        this.props.callbackFromParent3_text('No difficulty carrying a shopping bag or briefcase');
    if (value === 25)
        this.props.callbackFromParent3_text('Slight difficulty carrying a shopping bag or briefcase');
    if (value === 50)
        this.props.callbackFromParent3_text('Moderate difficulty carrying a shopping bag or briefcase');
    if (value === 75)
        this.props.callbackFromParent3_text('Severe difficulty carrying a shopping bag or briefcase');
    if (value === 100)
        this.props.callbackFromParent3_text('Unable to carry a shopping bag or briefcase');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>Carry a shopping bag or briefcase</h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <h4>Carry a shopping bag or briefcase</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}

class Buttons4 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent4(value);
    if (value === 0)
        this.props.callbackFromParent4_text('No difficulty washing back');
    if (value === 25)
        this.props.callbackFromParent4_text('Slight difficulty washing back');
    if (value === 50)
        this.props.callbackFromParent4_text('Moderate difficulty washing back');
    if (value === 75)
        this.props.callbackFromParent4_text('Severe difficulty washing back');
    if (value === 100)
        this.props.callbackFromParent4_text('Unable to wash back');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>Wash your back</h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <h4>Wash your back</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}

class Buttons5 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent5(value);
    if (value === 0)
        this.props.callbackFromParent5_text('No difficulty using a knife to cut food');
    if (value === 25)
        this.props.callbackFromParent5_text('Mild difficulty using a knife to cut food');
    if (value === 50)
        this.props.callbackFromParent5_text('Moderate difficulty using a knife to cut food');
    if (value === 75)
        this.props.callbackFromParent5_text('Severe difficulty using a knife to cut food');
    if (value === 100)
        this.props.callbackFromParent5_text('Unable to use a knife to cut food');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>Use a knife to cut food</h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <h4>Use a knife to cut food</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}

class Buttons6 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent6(value);
    if (value === 0)
        this.props.callbackFromParent6_text('No difficulty performing recreational activities in which force or impact taken through arm, shoulder or hand');
    if (value === 25)
        this.props.callbackFromParent6_text('Slight difficulty performing recreational activities in which force or impact taken through arm, shoulder or hand');
    if (value === 50)
        this.props.callbackFromParent6_text('Moderate difficulty performing recreational activities in which force or impact taken through arm, shoulder or hand');
    if (value === 75)
        this.props.callbackFromParent6_text('Severe difficulty performing recreational activities in which force or impact taken through arm, shoulder or hand');
    if (value === 100)
        this.props.callbackFromParent6_text('Unable to perform recreational activities in which force or impact taken through arm, shoulder or hand');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>Recreational activities in which you take some force or impact through your arm, shoulder or hand (e.g. golf, hammering, tennis, etc.)</h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <h4>Recreational activities in which you take some force or impact through your arm, shoulder or hand (e.g. golf, hammering, tennis, etc.)</h4>
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}

class Buttons7 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent7(value);
    if (value === 0)
        this.props.callbackFromParent7_text('Arm, shoulder or hand problem has not interfered with normal social activities');
    if (value === 25)
        this.props.callbackFromParent7_text('Arm, shoulder or hand problem has slightly interfered with normal social activities');
    if (value === 50)
        this.props.callbackFromParent7_text('Arm, shoulder or hand problem has moderately interfered with normal social activities');
    if (value === 75)
        this.props.callbackFromParent7_text('Arm, shoulder or hand problem has interfered quite a bit with normal social activities');
    if (value === 100)
        this.props.callbackFromParent7_text('Extreme interference with normal social activities due to arm, shoulder or hand problem');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h3>During the past week, to what extent has your arm, shoulder or hand problem interfered with your normal social activities with family, friends, neighbours or groups?</h3>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Not at all (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slightly (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderately (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Quite a bit (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extremely (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <h3>During the past week, to what extent has your arm, shoulder or hand problem interfered with your normal social activities with family, friends, neighbours or groups?</h3>
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Not at all (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slightly (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderately (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Quite a bit (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extremely (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}


class Buttons8 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }

    someFn = (value) => {
    this.props.callbackFromParent8(value);
    if (value === 0)
        this.props.callbackFromParent8_text('Arm, shoulder, or hand problem has not limited work or other regular daily activities');
    if (value === 25)
        this.props.callbackFromParent8_text('Arm, shoulder, or hand problem has slightly limited work or other regular daily activities');
    if (value === 50)
        this.props.callbackFromParent8_text('Arm, shoulder, or hand problem has moderately limited work or other regular daily activities');
    if (value === 75)
        this.props.callbackFromParent8_text('Arm, shoulder, or hand problem has very much limited work or other regular daily activities');
    if (value === 100)
        this.props.callbackFromParent8_text('Unable to work or perform other regular daily activities due to arm, shoulder, or hand problem');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h3>During the past week, were you limited in your work or other regular daily activities as a result of your arm, shoulder or hand problem?</h3>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Not limited at all (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slightly limited (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderately limited (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Very limited (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <h3>During the past week, were you limited in your work or other regular daily activities as a result of your arm, shoulder or hand problem?</h3>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Not limited at all (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Slightly limited (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderately limited (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Very limited (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Unable (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}


class Buttons9 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent9(value);
    if (value === 0)
        this.props.callbackFromParent9_text('No arm, shoulder or hand pain');
    if (value === 25)
        this.props.callbackFromParent9_text('Mild arm, shoulder or hand pain');
    if (value === 50)
        this.props.callbackFromParent9_text('Moderate arm, shoulder or hand pain');
    if (value === 75)
        this.props.callbackFromParent9_text('Severe arm, shoulder or hand pain');
    if (value === 100)
        this.props.callbackFromParent9_text('Extreme arm, shoulder or hand pain');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>Arm, shoulder or hand pain</h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <h4>Arm, shoulder or hand pain</h4>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}

class Buttons10 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent10(value);
    if (value === 0)
        this.props.callbackFromParent10_text('No tingling (pins and needles) in arm, shoulder or hand');
    if (value === 25)
        this.props.callbackFromParent10_text('Mild tingling (pins and needles) in arm, shoulder or hand');
    if (value === 50)
        this.props.callbackFromParent10_text('Moderate tingling (pins and needles) in arm, shoulder or hand');
    if (value === 75)
        this.props.callbackFromParent10_text('Severe tingling (pins and needles) in arm, shoulder or hand');
    if (value === 100)
        this.props.callbackFromParent10_text('Extreme tingling (pins and needles) in arm, shoulder or hand');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h4>Tingling (pins and needles) in your arm, shoulder or hand</h4>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme (100)</ToggleButton>
   </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <h4>Tingling (pins and needles) in your arm, shoulder or hand</h4>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} None (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Extreme (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}

class Buttons11 extends PureComponent {

    constructor(){
         super();
         this.state= {clicked: 0}
    }
    

    someFn = (value) => {
    this.props.callbackFromParent11(value);
    if (value === 0)
        this.props.callbackFromParent11_text('No difficulty sleeping because of pain in arm, shoulder or hand');
    if (value === 25)
        this.props.callbackFromParent11_text('Slight difficulty sleeping because of pain in arm, shoulder or hand');
    if (value === 50)
        this.props.callbackFromParent11_text('Moderate difficulty sleeping because of pain in arm, shoulder or hand');
    if (value === 75)
        this.props.callbackFromParent11_text('Severe difficulty sleeping because of pain in arm, shoulder or hand');
    if (value === 100)
        this.props.callbackFromParent11_text('So much difficulty with pain in arm, shoulder or hand that unable to sleep');
    this.setState({clicked: value});
    }

  render() {
    return (
    <div>
    <div class="hidden-xs">
    <h3>During the past week, how much difficulty have you had sleeping because of the pain in your arm, shoulder or hand?</h3>
    <ToggleButtonGroup justified type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} So much difficulty I can't sleep (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
    <div class="visible-xs">
    <ToggleButtonGroup vertical block type="radio" name="options" value = {this.state.clicked} onChange = {(value) => this.someFn(value)} defaultValue={0}>
    <h3>During the past week, how much difficulty have you had sleeping because of the pain in your arm, shoulder or hand?</h3>
    <ToggleButton bsStyle="btn-custom" value={0}> {(this.state.clicked === 0) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} No difficulty (0)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={25}> {(this.state.clicked === 25) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Mild difficulty (25)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={50}> {(this.state.clicked === 50) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Moderate difficulty (50)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={75}> {(this.state.clicked === 75) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} Severe difficulty (75)</ToggleButton>
    <ToggleButton bsStyle="btn-custom" value={100}> {(this.state.clicked === 100) ? <Glyphicon glyph="check" /> : <Glyphicon glyph="unchecked" />} So much difficulty I can't sleep (100)</ToggleButton>
    </ToggleButtonGroup>
    </div>
	</div>
  );
  }
}
    
    


  


class QuickDASH_Link extends PureComponent {
    
  constructor() {
    super();      
    this.state = {
      currentItem: '', //this is a relic of the tutorial
      username: '', //this is a relic of the tutorial
      user_id: '', //this is the name of the patinet submitting the survey
      clinician_to_share_with: '', //the email that users enter in order to share their score with a clinician
      scores: [], //this displays the scores saved for each clinician
      items: [], //this is a relic of the tutorial   
      user: null, //this is the email address or lack of email address for the clincian who is logged in 
      patient_filter: '', //this allows clinicians to sort for results from a single individual        
      patient_email_to_send_score: '', //this is the variable where clinicians enter the email of a patient they want to send a score to

        
    //Calculator variables    
        selectedValue1: 0,
        selectedValue1_text: 'No difficulty opening a tight or new jar',
        selectedValue2: 0,
        selectedValue2_text: 'No difficulty doing heavy household chores',
        selectedValue3: 0,
        selectedValue3_text: 'No difficulty carrying a shopping bag or briefcase',
        selectedValue4: 0,
        selectedValue4_text: 'No difficulty washing back',
        selectedValue5: 0,
        selectedValue5_text: 'No difficulty using a knife to cut food',
        selectedValue6: 0,
        selectedValue6_text: 'No difficulty performing recreational activities in which force or impact taken through arm, shoulder or hand',
        selectedValue7: 0,
        selectedValue7_text: 'Arm, shoulder or hand problem has not interfered with normal social activities',
        selectedValue8: 0,
        selectedValue8_text: 'Arm, shoulder, or hand problem has not limited work or other regular daily activities',
        selectedValue9: 0,
        selectedValue9_text: 'No arm, shoulder or hand pain',
        selectedValue10: 0,
        selectedValue10_text: 'No tingling (pins and needles) in arm, shoulder or hand',
        selectedValue11: 0,
        selectedValue11_text: 'No difficulty sleeping because of pain in arm, shoulder or hand',        
        
        
        
    }
  this.handleChange = this.handleChange.bind(this);
  this.handleSubmit = this.handleSubmit.bind(this);
  this.handleSubmitSendInvite = this.handleSubmitSendInvite.bind(this);      
  this.login = this.login.bind(this); 
  this.logout = this.logout.bind(this);
     
     
      
  }
    
      

    
componentDidMount() {



    
if (this.state.user != null){
    if(this.state.user.email === "orthotoolkit@gmail.com" | this.state.user.email === "neurologytoolkit@gmail.com"){    
          

  const QuickDASHScoresRef = firebase.firestore();
  QuickDASHScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  QuickDASHScoresRef.collection("quickdash_scores").get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  })
              
        
}  else {
    
  const QuickDASHScoresRef = firebase.firestore();
  QuickDASHScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  QuickDASHScoresRef.collection("quickdash_scores").where("shared_with", "==", this.state.user.email).get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  }) 
      
    
}
}
    

    
    
  auth.onAuthStateChanged((user) => {
    if (user) {
      this.setState({ user });
    }
      

if (this.state.user != null){
    if(this.state.user.email === "orthotoolkit@gmail.com" | this.state.user.email === "neurologytoolkit@gmail.com"){ 
        
  const QuickDASHScoresRef = firebase.firestore();
  QuickDASHScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  QuickDASHScoresRef.collection("quickdash_scores").get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  }) 
                       
        
} else {
    

    
  const QuickDASHScoresRef = firebase.firestore();
  QuickDASHScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  QuickDASHScoresRef.collection("quickdash_scores").where("shared_with", "==", this.state.user.email).get().then(querySnapshot =>{
      
      
      const data = querySnapshot.docs.map(doc => doc.data());
      
    this.setState({
      scores: data
    });  
      
  }) 
     
    
}
}      

    
      
  });    
    
}    
    
handleChange(e) {
  this.setState({
    [e.target.name]: e.target.value
  });
} 
    
handleSubmit(e) {
  e.preventDefault();
 
    
  const QuickDASHScoresRef = firebase.firestore();
  QuickDASHScoresRef.settings({
      timestampsInSnapshots: true
  });  
if (this.props.requestSurveyID.slice(0,4) !== 'zzzz'){    
  const quickdash_score = QuickDASHScoresRef.collection("quickdash_scores").doc(this.props.requestSurveyID).set({      
    shared_with: this.props.clinicianSendingEmail,
    user: this.props.submitterName,
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    score_name: 'QuickDASH',
    Question_01_QuickDASH: this.state.selectedValue1,
    Question_02_QuickDASH: this.state.selectedValue2,
    Question_03_QuickDASH: this.state.selectedValue3,
    Question_04_QuickDASH: this.state.selectedValue4,
    Question_05_QuickDASH: this.state.selectedValue5,
    Question_06_QuickDASH: this.state.selectedValue6,
    Question_07_QuickDASH: this.state.selectedValue7,            
    Question_08_QuickDASH: this.state.selectedValue8,
    Question_09_QuickDASH: this.state.selectedValue9,
    Question_10_QuickDASH: this.state.selectedValue10,
    Question_11_QuickDASH: this.state.selectedValue11,
    QuickDASH_Score: ((this.state.selectedValue1 + this.state.selectedValue2 + this.state.selectedValue3 + this.state.selectedValue4 + this.state.selectedValue5 + this.state.selectedValue6 + this.state.selectedValue7 + this.state.selectedValue8 + this.state.selectedValue9 + this.state.selectedValue10 + this.state.selectedValue11)/11).toFixed(1),   
  });
}
else {
  const quickdash_score = QuickDASHScoresRef.collection("quickdash_scores").add({      
    shared_with: this.props.clinicianSendingEmail,
    user: this.props.submitterName,
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    text_timestamp: this.props.requestSurveyID.substring(4),      
    score_name: 'QuickDASH',
    Question_01_QuickDASH: this.state.selectedValue1,
    Question_02_QuickDASH: this.state.selectedValue2,
    Question_03_QuickDASH: this.state.selectedValue3,
    Question_04_QuickDASH: this.state.selectedValue4,
    Question_05_QuickDASH: this.state.selectedValue5,
    Question_06_QuickDASH: this.state.selectedValue6,
    Question_07_QuickDASH: this.state.selectedValue7,            
    Question_08_QuickDASH: this.state.selectedValue8,
    Question_09_QuickDASH: this.state.selectedValue9,
    Question_10_QuickDASH: this.state.selectedValue10,
    Question_11_QuickDASH: this.state.selectedValue11,
    QuickDASH_Score: ((this.state.selectedValue1 + this.state.selectedValue2 + this.state.selectedValue3 + this.state.selectedValue4 + this.state.selectedValue5 + this.state.selectedValue6 + this.state.selectedValue7 + this.state.selectedValue8 + this.state.selectedValue9 + this.state.selectedValue10 + this.state.selectedValue11)/11).toFixed(1),      
  });      
}     
  this.setState({
    clinician_to_share_with: '',
    user_id: '',     
  });
    alert('Thank you for using OrthoPowerTools! Your submission was received and will be shared with the following provider: ' + this.props.clinicianSendingEmail + '. You may now close this alert and the entire window.');      
}  
         
    
handleSubmitSendInvite(e) {
  e.preventDefault();  
  const PatientInvites = firebase.firestore();
  PatientInvites.settings({
      timestampsInSnapshots: true
  });
  const patient_invites = PatientInvites.collection("quickdash_patient_invites").add({
    patient_email_to_send_score: this.state.patient_email_to_send_score,
    clinician_who_sent: this.state.user.email,  
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),      
  });
  this.setState({
    patient_email_to_send_score: '',    
  });
    alert('Thank you for using OrthoPowerTools! A message has been sent to the entered email address with a link to complete a survey.');    
    
}      
  
    
    
    
  
login() {
  auth.signInWithPopup(provider) 
    .then((result) => {
      const user = result.user;
      this.setState({
        user
      });
    });
    
}
    
logout() {
  auth.signOut()
    .then(() => {
      this.setState({
        user: null
      });
    });
}
    
  //Calculator Methods
    myCallback1 = (dataFromChild) => {
    this.setState({selectedValue1: dataFromChild});
    }
 
    myCallback1_text = (dataFromChild) => {
    this.setState({selectedValue1_text: dataFromChild});
    }
    
    myCallback2 = (dataFromChild) => {
    this.setState({selectedValue2: dataFromChild});
    }
    
    myCallback2_text = (dataFromChild) => {
    this.setState({selectedValue2_text: dataFromChild});
    }
    
    myCallback3 = (dataFromChild) => {
    this.setState({selectedValue3: dataFromChild});
    }
    
    myCallback3_text = (dataFromChild) => {
    this.setState({selectedValue3_text: dataFromChild});
    }    
    
    myCallback4 = (dataFromChild) => {
    this.setState({selectedValue4: dataFromChild});
    }
    
    myCallback4_text = (dataFromChild) => {
    this.setState({selectedValue4_text: dataFromChild});
    }  
    
    myCallback5 = (dataFromChild) => {
    this.setState({selectedValue5: dataFromChild});
    }
    
    myCallback5_text = (dataFromChild) => {
    this.setState({selectedValue5_text: dataFromChild});
    }    
    
    myCallback6 = (dataFromChild) => {
    this.setState({selectedValue6: dataFromChild});
    }
    
    myCallback6_text = (dataFromChild) => {
    this.setState({selectedValue6_text: dataFromChild});
    }      
    
    myCallback7 = (dataFromChild) => {
    this.setState({selectedValue7: dataFromChild});
    }
    
    myCallback7_text = (dataFromChild) => {
    this.setState({selectedValue7_text: dataFromChild});
    }    
    
    myCallback8 = (dataFromChild) => {
    this.setState({selectedValue8: dataFromChild});
    }
    
    myCallback8_text = (dataFromChild) => {
    this.setState({selectedValue8_text: dataFromChild});
    }      
    
    myCallback9 = (dataFromChild) => {
    this.setState({selectedValue9: dataFromChild});
    }
    
    myCallback9_text = (dataFromChild) => {
    this.setState({selectedValue9_text: dataFromChild});
    }    
    
    myCallback10 = (dataFromChild) => {
    this.setState({selectedValue10: dataFromChild});
    }
    
    myCallback10_text = (dataFromChild) => {
    this.setState({selectedValue10_text: dataFromChild});
    }

    myCallback11 = (dataFromChild) => {
    this.setState({selectedValue11: dataFromChild});
    }
    
    myCallback11_text = (dataFromChild) => {
    this.setState({selectedValue11_text: dataFromChild});
    }   
 

  
    
    

    
render() {     
    
  return (
     
    <div className='app'>
      <header>
        <div className="wrapper">
        <Link to="/"><img src={mainLogo} style={{padding:15,width:200}} alt="orthotoolkit logo"/></Link>      
        </div>
      </header>            
            
            
            <div className="App">
                <h1>QuickDASH Calculator</h1>
                <h4>Hello, {this.props.submitterName}, your clinician, {this.props.clinicianSendingEmail}, has sent you this survey to help further understand your health. Please click the appropriate buttons below and then click "Submit Score". Please note that your <u>digital privacy is taken very seriously</u> and a number of technologies have been implemented to protect the privacy and integrity of your data, including the use of SSL encryption, HIPAA compliant storage, and state-of-the-art authentication services. Your data <u>will never be shared with anyone other than the assigned clinician</u>.</h4>

            <form onSubmit={this.handleSubmit}>

        <br />
        <StickyContainer>
        <Sticky>
        {({ style }) => <div className="sticky_style" style={style}><Well bsSize="small">QuickDASH Score: {

        ((this.state.selectedValue1 + this.state.selectedValue2 + this.state.selectedValue3 + this.state.selectedValue4 + this.state.selectedValue5 + this.state.selectedValue6 + this.state.selectedValue7 + this.state.selectedValue8 + this.state.selectedValue9 + this.state.selectedValue10 + this.state.selectedValue11)/11).toFixed(1)   


        } / {100
        } = {
        ((this.state.selectedValue1 + this.state.selectedValue2 + this.state.selectedValue3 + this.state.selectedValue4 + this.state.selectedValue5 + this.state.selectedValue6 + this.state.selectedValue7 + this.state.selectedValue8 + this.state.selectedValue9 + this.state.selectedValue10 + this.state.selectedValue11)/11).toFixed(1)   
        } %

        <br />      

        Graphical QuickDASH Score: (%)
        <ProgressBar>
        <ProgressBar active now={
        100-((this.state.selectedValue1 + this.state.selectedValue2 + this.state.selectedValue3 + this.state.selectedValue4 + this.state.selectedValue5 + this.state.selectedValue6 + this.state.selectedValue7 + this.state.selectedValue8 + this.state.selectedValue9 + this.state.selectedValue10 + this.state.selectedValue11)/11).toFixed(1)                         
                                  }/>
        <ProgressBar active bsStyle="danger" now={
            ((this.state.selectedValue1 + this.state.selectedValue2 + this.state.selectedValue3 + this.state.selectedValue4 + this.state.selectedValue5 + this.state.selectedValue6 + this.state.selectedValue7 + this.state.selectedValue8 + this.state.selectedValue9 + this.state.selectedValue10 + this.state.selectedValue11)/11).toFixed(1)     
        }/>
        </ProgressBar>
        </Well></div>}
        </Sticky>                                                                

       

        <br/>            
        <br/>                
	    <h3>Please rate your ability to do the following activities in the last week:</h3>
        <Buttons1 callbackFromParent1={this.myCallback1} callbackFromParent1_text={this.myCallback1_text}/>
        <Buttons2 callbackFromParent2={this.myCallback2} callbackFromParent2_text={this.myCallback2_text}/>
        <Buttons3 callbackFromParent3={this.myCallback3} callbackFromParent3_text={this.myCallback3_text}/>
        <Buttons4 callbackFromParent4={this.myCallback4} callbackFromParent4_text={this.myCallback4_text}/>
        <Buttons5 callbackFromParent5={this.myCallback5} callbackFromParent5_text={this.myCallback5_text}/>
        <Buttons6 callbackFromParent6={this.myCallback6} callbackFromParent6_text={this.myCallback6_text}/>
        <Buttons7 callbackFromParent7={this.myCallback7} callbackFromParent7_text={this.myCallback7_text}/>
        <Buttons8 callbackFromParent8={this.myCallback8} callbackFromParent8_text={this.myCallback8_text}/>
        <h3>Please rate the severity of the following symptoms in the last week:</h3>
        <Buttons9 callbackFromParent9={this.myCallback9} callbackFromParent9_text={this.myCallback9_text}/>
        <Buttons10 callbackFromParent10={this.myCallback10} callbackFromParent10_text={this.myCallback10_text}/>
        <Buttons11 callbackFromParent11={this.myCallback11} callbackFromParent11_text={this.myCallback11_text}/>
        </StickyContainer>

        <br />
                    
        <button style = {{width: '100%'}}>Submit Score</button>                    
                    
            </form>    

            </div>     

    </div>
            
      
      
  );
}
}
    
export default withRouter(QuickDASH_Link);

